import { createFileRoute, useParams, useSearch } from "@tanstack/react-router"
import { z } from "zod"
import { StudentCompareReview } from "@/pages/students/StudentCompareReview"

const searchSchema = z.object({
  existingStudentId: z.number(),
})

export const Route = createFileRoute(
  "/beheer/todo/$studentRegistrationId/vergelijken",
)({
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { studentRegistrationId } = useParams({
    from: "/beheer/todo/$studentRegistrationId/vergelijken",
  })
  const { existingStudentId } = useSearch({
    from: "/beheer/todo/$studentRegistrationId/vergelijken",
  })

  return (
    <StudentCompareReview
      studentRegistrationId={studentRegistrationId}
      existingStudentId={existingStudentId}
    />
  )
}
